// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ufPd","requiredAsterisk":"Info_requiredAsterisk__3Du4r"};